module.exports = __webpack_public_path__ + "img/ayuda-verificacion-2.ac3046b3.png";